import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { SidenavService } from '../services/sidenav.service';

@Injectable({
    providedIn: 'root',
})
export class SidenavGuard implements CanActivate {
    constructor(private sidenavService: SidenavService) { }

    canActivate() {
        return this.sidenavService.isSidenavDataFetched$().pipe(
            map((isFetched: boolean) => {
                return isFetched;
            })
        );
    }
}
